import _isFunction from "lodash/isFunction";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Icon } from '../Icon';
import { useIsMounted } from '../hooks';
import { Spinner } from '../Loader';
import { buttonContainer } from './styles'; // eslint-disable-next-line max-len

import { jsx as ___EmotionJSX } from "@emotion/react";
var externalLinkExpression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i;

var Button = function Button(props) {
  var children = props.children,
      onClick = props.onClick,
      disabled = props.disabled,
      leftIcon = props.leftIcon,
      rightIcon = props.rightIcon,
      className = props.className,
      preventDefault = props.preventDefault,
      stopPropagation = props.stopPropagation,
      linkTo = props.linkTo,
      _props$loading = props.loading,
      loadingProp = _props$loading === void 0 ? false : _props$loading,
      _props$target = props.target,
      target = _props$target === void 0 ? '_blank' : _props$target;

  var _useState = useState(loadingProp),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var buttonStyles = buttonContainer(props, loading);
  var isMounted = useIsMounted();
  useEffect(function () {
    loadingProp !== loading && setLoading(loadingProp);
  }, [loadingProp]);

  var handleClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!disabled) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", e.preventDefault());

            case 2:
              preventDefault && e.preventDefault();
              stopPropagation && e.stopPropagation();

              if (!_isFunction(onClick)) {
                _context.next = 9;
                break;
              }

              setLoading(true);
              _context.next = 8;
              return onClick(e);

            case 8:
              isMounted.current && setLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return linkTo ? externalLinkExpression.test(linkTo) ? ___EmotionJSX("a", _extends({
    href: linkTo,
    css: buttonStyles,
    target: target,
    rel: "noreferrer",
    onClick: handleClick
  }, className && {
    className: className
  }), leftIcon !== null && leftIcon !== void 0 && leftIcon.iconName ? ___EmotionJSX(Icon, leftIcon) : leftIcon, children, rightIcon !== null && rightIcon !== void 0 && rightIcon.iconName ? ___EmotionJSX(Icon, rightIcon) : rightIcon) : ___EmotionJSX(Link, _extends({
    to: linkTo
  }, className && {
    className: className
  }, {
    css: buttonStyles,
    onClick: handleClick
  }), leftIcon !== null && leftIcon !== void 0 && leftIcon.iconName ? ___EmotionJSX(Icon, leftIcon) : leftIcon, children, rightIcon !== null && rightIcon !== void 0 && rightIcon.iconName ? ___EmotionJSX(Icon, rightIcon) : rightIcon) : ___EmotionJSX("div", _extends({
    role: "button",
    tabIndex: 0,
    onClick: handleClick,
    css: buttonStyles
  }, className && {
    className: className
  }), leftIcon !== null && leftIcon !== void 0 && leftIcon.iconName ? ___EmotionJSX(Icon, leftIcon) : leftIcon, children, rightIcon !== null && rightIcon !== void 0 && rightIcon.iconName ? ___EmotionJSX(Icon, rightIcon) : rightIcon, ___EmotionJSX(Spinner, {
    loading: loading,
    size: 30,
    color: "white"
  }));
};

Button.propTypes = {
  children: PropTypes.any,
  type: PropTypes.oneOf(['primary', 'secondary', 'default', 'success', 'warning', 'info', 'danger', 'link']),
  outline: PropTypes.bool,
  clear: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onClick: PropTypes.func,
  preventDefault: PropTypes.bool,
  stopPropagation: PropTypes.bool,
  color: PropTypes.string,
  backColor: PropTypes.string,
  small: PropTypes.bool,
  large: PropTypes.bool,
  className: PropTypes.string,
  leftIcon: PropTypes.any,
  rightIcon: PropTypes.any,
  linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  loading: PropTypes.bool,
  target: PropTypes.string
};
export default Button;